import { fetchClass } from "../plugins/fetchAuth.ts";
import {getUrls} from "../plugins/config.ts";
// var sso = "http://localhost:9000"; //config.sso;
// var coreURL = ""; //config.coreURL;
// import dummyData from "../core/json/dummyData/target.json"
// const { baseFida_URL } = getUrls();
// const baseFida_URL = config.baseFida_URL;
export function APIgetReportingData(params,url) {
  try
  {
    if(url == null || url == '' )
    {
      url = "getReportingData"
    }
    // "headers": {
    //           "Authorization": "bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJkb1lIcnVyZGVrTU5hZGtKTiIsImFjY2Vzc1Rva2VuRXhwIjp7ImRhdGUiOiIyMDI0LTA2LTIwIiwidGltZSI6IjE2OjM0OjMyIiwidGltZVN0YW1wIjoxNzE4ODY4ODcyNTE3LCJnbXQiOiIrMDkwMCJ9LCJyZWZyZXNoVG9rZW5FeHAiOnsiZGF0ZSI6IjIwMjQtMDYtMjAiLCJ0aW1lIjoiMTY6MzQ6MzIiLCJ0aW1lU3RhbXAiOjE3MTg4Njg4NzI1MTgsImdtdCI6IiswOTAwIn0sImlhdCI6MTcxNjI3Njg3MiwiZXhwIjoxNzE2Mjc2OTMyfQ.GPL40BCVaduqnqyB7VUU5QgcCCqii08-mrqRadKyjoM",
    //           "Accept-Language": "en",
    //           "Content-Type": "application/json;charset=utf-8"
    //       },
    
    if(params.storeCodes == null || params.storeCodes.length<=0  || params.storeCodes[0]==null || params.storeCodes[0]=="")
    {
      return null;
    }
    return fetchClass(//,url
      `${getUrls().baseFida_URL}/api/`+url,
      {
        method: "POST",
        body: params,
      },
      {
          "Authorization": "bearer "+localStorage.getItem('accessToken'),//"bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJkb1lIcnVyZGVrTU5hZGtKTiIsImFjY2Vzc1Rva2VuRXhwIjp7ImRhdGUiOiIyMDI0LTA2LTIwIiwidGltZSI6IjE2OjM0OjMyIiwidGltZVN0YW1wIjoxNzE4ODY4ODcyNTE3LCJnbXQiOiIrMDkwMCJ9LCJyZWZyZXNoVG9rZW5FeHAiOnsiZGF0ZSI6IjIwMjQtMDYtMjAiLCJ0aW1lIjoiMTY6MzQ6MzIiLCJ0aW1lU3RhbXAiOjE3MTg4Njg4NzI1MTgsImdtdCI6IiswOTAwIn0sImlhdCI6MTcxNjI3Njg3MiwiZXhwIjoxNzE2Mjc2OTMyfQ.GPL40BCVaduqnqyB7VUU5QgcCCqii08-mrqRadKyjoM",
          "Accept-Language": "en",
          "Content-Type": "application/json;charset=utf-8"
      
      },
      false
    );

  }
  catch(e) {
    console.log(e)
    return null;
  }
}
// target Achivement